import {
    RECEIVE_CART_AND_USER_PROFILE,
    SET_AMOUNT,
    ADD_TO_CART,
    EMPTY_CART,
} from '../actions/types';

// [{sku: ..., amount: 1}]
const emptyCart = [];

const cart = (state = emptyCart, action) => {
    switch (action.type) {
        case RECEIVE_CART_AND_USER_PROFILE:
            if (action.payload) {
                return action.payload.cart;
            } else {
                return emptyCart;
            }
        case EMPTY_CART:
            return emptyCart;
        case ADD_TO_CART:
            return [...state, { sku: action.sku, amount: action.amount }];
        case SET_AMOUNT:
            if (action.amount === 0) {
                return [...state.filter(({ sku }) => sku !== action.sku)];
            } else {
                return state.map((ele) => {
                    if (action.sku === ele.sku)
                        return { sku: action.sku, amount: action.amount };
                    return ele;
                });
            }
        default:
            return state;
    }
};

export default cart;
